import { useLoading } from "context/LoadingContext";
import { ToastContext } from "context/ToastContext";
import useDocumentTitle from "hooks/useDocumentTitle";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useCreateManySequestrationRulesetsMutation,
  useCreateSequestrationRulesetMutation,
} from "store/queries/sequestrationRulesets";

import {
  ISequestrationRulesetFormData,
  INITIAL_SEQUESTRATION_RULESET_FORM_DATA,
  SequestrationRulesetForm,
} from "./components/SequestrationRulesetForm";

export function CreateSequestrationRulesetPage() {
  useDocumentTitle("Create Sequester Rule");
  const navigate = useNavigate();
  const { setIsLoading } = useLoading();
  const { current: toastElement } = useContext(ToastContext);
  const [createSingle] = useCreateSequestrationRulesetMutation();
  const [createMany] = useCreateManySequestrationRulesetsMutation();
  const [formData, setFormData] = useState<ISequestrationRulesetFormData>(
    INITIAL_SEQUESTRATION_RULESET_FORM_DATA
  );

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      // Default-rule creation goes through the single endpoint; everything else fans out.
      if (formData.isDefault) {
        await createSingle({
          isDefault: true,
          percent: formData.percent,
          contractLanguage: formData.contractLanguage || null,
        }).unwrap();
      } else {
        await createMany({
          providerIds: formData.providerIds,
          payerIds: formData.payerIds,
          percent: formData.percent,
          contractLanguage: formData.contractLanguage || null,
        }).unwrap();
      }
      toastElement?.show({
        severity: "success",
        summary: "Sequester rule created",
      });
      navigate("/payer-rules");
    } catch (err) {
      const detail =
        (err as { data?: { message?: string } })?.data?.message ??
        "Failed to create sequester rule";
      toastElement?.show({
        severity: "error",
        summary: "Could not create sequester rule",
        detail,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <SequestrationRulesetForm
      title="Create Sequester Rule"
      submitLabel="Create"
      mode="create"
      formData={formData}
      onChange={setFormData}
      onSubmit={handleSubmit}
    />
  );
}
